import moment from "moment";
import currentAccounts from "@/store/currentAccounts/currentAccounts.js";

class employee {
  constructor(empId, name, balance, dateStart, dateEnd, topeMax, topeMin) {
    this.empId = empId;
    this.name = name;
    this.balanceTable =
      currentAccounts.state.edit.unit === "D"
        ? balance
        : employee.convertToTime(balance);
    this.balance =
      currentAccounts.state.edit.unit === "D"
        ? balance
        : employee.convertToTime(balance);
    this.dateStart = dateStart
      ? moment.utc(dateStart).format("DD-MM-YYYY")
      : null;
    this.dateEnd = dateEnd ? moment.utc(dateEnd).format("DD-MM-YYYY") : null;
    this.dateStartInput = dateStart
      ? moment.utc(dateStart).format("YYYY-MM-DD")
      : null;
    this.dateEndInput = dateEnd
      ? moment.utc(dateEnd).format("YYYY-MM-DD")
      : null;
    this.topeMax =
      currentAccounts.state.edit.unit === "D"
        ? topeMax
        : employee.convertToTime(topeMax);
    this.topeMaxTable =
      currentAccounts.state.edit.unit === "D"
        ? topeMax
        : employee.convertToTime(topeMax);
    this.topeMin =
      currentAccounts.state.edit.unit === "D"
        ? topeMin
        : employee.convertToTime(topeMin);
    this.topeMinTable =
      currentAccounts.state.edit.unit === "D"
        ? topeMin
        : employee.convertToTime(topeMin);
  }

  static fromJson({
    empId,
    nomEmpleado,
    saldo,
    fecDesde,
    fecHasta,
    topeMax,
    topeMin,
  }) {
    return new employee(
      empId,
      nomEmpleado,
      saldo,
      fecDesde,
      fecHasta,
      topeMax,
      topeMin
    );
  }

  static convertToTime(minutes) {
    const isNegative = minutes < 0;
    const absoluteMinutes = Math.abs(minutes);

    const hours = Math.floor(absoluteMinutes / 60)
      .toString()
      .padStart(2, "0");
    const mins = (absoluteMinutes % 60).toString().padStart(2, "0");

    return `${isNegative ? "-" : ""}${hours}:${mins}`;
  }
}

export default employee;
